module.exports = __webpack_public_path__ + "img/app1.161bfd24.svg";